export default {
  // Product text configuration
  CURRENCY_UNIT_TEXT: '元',
  currencyUnit: '¥',
  OUT_OF_STOCK: '目前没货',
  OFF_THE_SHELVES: '已下架',
  selected: '已选',
  selectAll: '全选',
  pickAnotherOne: '再选1件',
  DOTDPrice: '镇店价',
  BEST_DEAL: '特卖汇',
  discountPrice: '优惠价',
  specialSalePrice: '特卖价',
  cheaperSinceAdded: '比加入时下降',
  timeRemaining: '距结束',
  thisItemNotInFreeShippingActivity: '此商品不参与满300元免运费',
  addToCollection: '移入收藏',
  removeFromCollection: '移出收藏',
  share: '分享',
  delete: '删除',
  piece: '件',
  discountThreeHundredMinusTwenty: '新人全场满{amount}减{promotion}',
  FULL_REDUCTION_COUPON: '全场满{amount}减{promotion}',
  discount: '优惠',
  numberOfGoods: '件商品',
  priceDiscounted: '价格已优惠',
  salePrice: '特卖价格',
  // Unlogged configuration
  notYetLogin: '亲，您还没登录哦',
  goLogIn: '登陆您的Amazon账户',
  // Date Display Configuration
  completeDateFormat: 'YYYY年MM月DD日',
  shortDateFormat: 'MM月DD日',
  DOTD: '镇店之宝',
  DEAL_OF_THE_DAY: '镇店之宝',
  myFavorites: '我的收藏夹',
  commmented: '已评价',
  toComment: '去评价',
  coupon: '优惠券',
  favorites: '收藏夹',
  page: '页面',
  deliveryAddress: '收货地址',
  clearanceInformation: '清关信息',
  contactCS: '联系客服',
  toBeShipped: '待发货',
  toBeReceived: '待收货',
  toBeCommented: '待评价',
  returnAndAfterSale: '退货/售后',
  myOrder: '我的订单',
  usable: '可使用',
  myCoupon: '我的优惠券',
  buyGift: '买赠',
  freeDelivery: '免运费',
  buyMore: '加购',
  pleaseLogin: '请登录',
  newCustomerCoupon: '新人优惠券',
  claimFailed: '领取失败',
  // time
  year: '年',
  month: '月',
  day: '日',
  copy: '复制',
  copySucceed: '复制成功',
  COMPLETE_DATE_FORMAT: 'YYYY年M月D日',
  SHORT_DATE_FORMAT: 'M月D日',
  FREE_SHIPPING: '满300元免运费',
  BEST_SELLING_ITEM_RECOMMENDATION: '畅销单品推荐',
  DOOR_TO_DOOR_PICK_UP_AND_RETURN: '上门取退',
  DIRECT_SHIPPING: '销售发货',
  AUTHENTIC_GUARANTEE: '正品保证',
  ADD_TO_CART: '加入购物车',
  PAY_NOW: '立即支付',
  AFTER_THE_COUPON_DISCOUNT: '券后',
  SAVE: '节省',
  PLEASE_PROVIDE_THE_KYC_INFO: '请填写订购人',
  ONLY_REMAINING: '仅剩',
  COUNT: '数量',
  RECOMMENDED_COMMODITIES: '专属推荐',
  PLEASE: '请',
  SUCCESS_ADDED_CART: '已加入购物车',
  UP: '起',
  PRODUCTS_HAVE_BEEN_SOLD_OUT: '商品已抢光',
  TODAY_DEAL: '今日特惠',
  NO_MORE: '没有更多了',
  TIME_REMAINING: '距结束',
  AMZN: '亚马逊',
  DAYS: '天',
  ILLUSTRATE: '说明',
  ARRIVED: '已到达',
  SINGLE_PRODUCT_EXCEED_MAX_LIMIT: '商品数量已超限，无法加入购物车',
  PRODUCTS_HAVE_BEEN_SOLD_OUT_UNABLE_ADD_CART: '商品已抢光，无法加入购物车',
  SOME_PRODUCTS_ADDED_TO_CART_SUCCESSFULLY: '部分商品已加入购物车',
  PLEASE_LOGIN_YOUR_ACCOUNT: '请先登录账户',
  PLEASE_AGREE_TO_PIPL: '请先同意PIPL授权',
  NO_ASIN_INFO: '暂无商品信息'
};
